var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/condition/condition-scale.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.vintage.numberOfConditionLevels",0]));
frame.set("numberOfConditionLevels", t_1, true);
if(frame.topLevel) {
context.setVariable("numberOfConditionLevels", t_1);
}
if(frame.topLevel) {
context.addExport("numberOfConditionLevels", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.vintage.conditionValue"]));
frame.set("qualityLevel", t_2, true);
if(frame.topLevel) {
context.setVariable("qualityLevel", t_2);
}
if(frame.topLevel) {
context.addExport("qualityLevel", t_2);
}
output += "\n\n";
output += "\n<div class=\"c-condition__outer\" data-qa-condition-scale>\n\n    ";
frame = frame.push();
var t_5 = (lineno = 6, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,runtime.contextOrFrameLookup(context, frame, "numberOfConditionLevels")]));
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("currentDot", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
output += "\n\n       <div class=\"c-condition__ball ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == runtime.contextOrFrameLookup(context, frame, "qualityLevel")) {
output += "is-active";
;
}
output += "\"></div>\n\n    ";
;
}
}
frame = frame.pop();
output += "\n\n</div>\n\n";
output += "\n<div class=\"c-condition__labels\">\n\n    <p class=\"c-condition__label\">";
output += runtime.suppressValue((lineno = 17, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_condition-low"])), env.opts.autoescape);
output += "</p>\n\n    <p class=\"c-condition__label\">";
output += runtime.suppressValue((lineno = 19, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_condition-medium"])), env.opts.autoescape);
output += "</p>\n\n    <p class=\"c-condition__label\">";
output += runtime.suppressValue((lineno = 21, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_condition-high"])), env.opts.autoescape);
output += "</p>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/condition/condition-scale.j2"] , dependencies)